<template>
    <div id="tradingroom-header" class="py-6 flex flex-col lg:flex-row gap-8 justify-between">
        <div class="w-2/3 lg:w-2/6">
            <!-- <Icon type="TradingroomLogo" viewBox="0 0 562 86" width="100%" height="100%"/> -->
            <img class="w-[26rem]" :src="$asset('/hkcm/images/hkcm-news.png', 'public')"
                :alt="getRegion() === 'de' ? 'HKCM News Logo' : 'HKCM Global News Logo'"
                :title="getRegion() === 'de' ? 'HKCM News Logo' : 'HKCM Global News Logo'" />
            <h6 class="tracking-[.15rem] font-extralight">{{ $t('news_independent') }}. {{ $t('news_relevant') }}. {{
                $t('news_critical') }}.</h6>
        </div>
    </div>
</template>

<script>
import { getRegion } from '../../helpers.js';

export default {
    data: () => ({
        scrollAtTop: true
    }),

    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
        getRegion,
        handleScroll() {
            let onTop = window.scrollY < 100;
            if (this.scrollAtTop != onTop) {
                this.scrollAtTop = !this.scrollAtTop;
            }
        },

        scrollUp() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style scoped>
.hidden-on-top {
    opacity: 50;
    bottom: -8rem;
}
</style>
